// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AccountMenuButton-cls1__ea30b44a6f93b4d403e8{/*!*/}.AccountMenuButton-cls2___29eca39821e46997e02{position:absolute;top:2px;left:30px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AccountMenuButton-cls1__ea30b44a6f93b4d403e8",
	"cls2": "AccountMenuButton-cls2___29eca39821e46997e02 AccountMenuButton-cls1__ea30b44a6f93b4d403e8"
};
export default ___CSS_LOADER_EXPORT___;
